exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cwSwitchWrapper[data-v-a38610c8]{border:1px solid #becdd7;border-radius:8px;padding-left:32px}", ""]);

// exports
